module.exports = __webpack_public_path__ + "img/certificate-status-0.0ec69318.png";